module.exports = __webpack_public_path__ + "img/it_it.954929c8.png";